import React from "react";

const CTA_IMG =
  "https://images.unsplash.com/photo-1678984239420-43cdc183bce6?fm=jpg&q=80&w=2000&auto=format&fit=crop";

export const CtaBand = () => (
  <div
    data-testid="cta-band"
    className="relative text-white py-[72px] lg:py-[88px]"
    style={{
      backgroundImage: `linear-gradient(115deg, rgba(4,16,32,0.92), rgba(6,40,30,0.86)), url(${CTA_IMG})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <div className="mx-auto max-w-[1180px] px-5 lg:px-8 grid md:grid-cols-[1.3fr_auto] gap-10 items-center">
      <div>
        <h2 className="font-display font-bold text-2xl sm:text-[30px] lg:text-[34px] leading-[1.15] max-w-[20ch]">
          Five years is shorter than it sounds when a PHA cycle is due.
        </h2>
        <p className="mt-3.5 font-body text-[15.5px] text-[#C7D1DC] max-w-[48ch]">
          If a revalidation, a new SIS verification, or a facility siting study is already on your
          calendar, start the scoping conversation now.
        </p>
      </div>
      <a
        href="#contact"
        data-testid="cta-band-button"
        className="inline-flex items-center justify-center px-7 py-4 text-[14.5px] font-semibold text-white bg-[#0E8A57] hover:bg-[#0F9A62] rounded-[2px] transition-colors"
      >
        Schedule a Technical Audit
      </a>
    </div>
  </div>
);
